import Vue from 'vue';

function makeAjaxRequest(method, url, body) {
  if (window.jQuery) {
    return jQuery.ajax({
      method: method,
      dataType: 'json',
      url: url,
      data: body,
      xhrFields: {
        withCredentials: true
      }
    });
  } else {
    return fetch(url, {
      method: method,
      mode: 'cors',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json();
    });
  }
} //


var script = {
  data: function data() {
    return {
      ajaxLoaded: false,
      loggedIn: false,
      user: undefined,
      csrfToken: this.$root.config.CSRF_TOKEN || ''
    };
  },
  apollo: {
    user: function user() {
      return this.$root.config.APOLLO_USER_QUERY;
    }
  },
  created: function created() {
    if (this.$apollo) {
      // Assume that if apollo exists we're on the customer portal already
      this.loggedIn = true;
    } else {
      // If apollo doesn't exist we need to make a plain old AJAX query to get the required data
      this.reload();
    }
  },
  computed: {
    loaded: function loaded() {
      return this.$apollo ? !this.$apollo.loading : this.ajaxLoaded;
    }
  },
  methods: {
    reload: function reload() {
      var _this = this;

      makeAjaxRequest('GET', "".concat(this.$root.config.API_URL, "/sessions/check")).then(function (response) {
        _this.ajaxLoaded = true;
        _this.loggedIn = response.loggedIn;
        _this.csrfToken = response.csrfToken;
        _this.user = response.user;
      })["catch"](function (error) {
        _this.ajaxLoaded = true;
        _this.loggedIn = false;
      });
    }
  }
};
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "login-check-query"
  }, [_vm._t("default", null, {
    loaded: _vm.loaded,
    loggedIn: _vm.loggedIn,
    user: _vm.user,
    csrfToken: _vm.csrfToken
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__ = function __vue_create_injector__() {};
/* style inject SSR */


var LoginCheckQuery = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, __vue_create_injector__, undefined); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var script$1 = {
  props: ['name'],
  computed: {
    iconPath: function iconPath() {
      return "".concat(this.$root.config.ICON_PATH, "#").concat(this.name);
    }
  }
};
/* script */

var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__$1() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 72 72"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.iconPath
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = "data-v-d25e4778";
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* component normalizer */

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__$1 = function __vue_create_injector__$1() {};
/* style inject SSR */


var Icon = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, __vue_create_injector__$1, undefined);

var SUFFIXES = ['th', 'st', 'nd', 'rd'];

function ordinalize(number) {
  var value = number % 100;
  var suffix = SUFFIXES[(value - 20) % 10] || SUFFIXES[value] || SUFFIXES[0];
  return "".concat(number).concat(suffix);
} //


var script$2 = {
  props: ['user', 'csrfToken'],
  components: {
    Icon: Icon
  },
  data: function data() {
    // Defined only on the customer portal; this prevents Vue complaining about it being undefined elsewhere
    if (!this.$welcomePopup) {
      return {
        $welcomePopup: undefined
      };
    }
  },
  computed: {
    logoutUrl: function logoutUrl() {
      var url = "".concat(this.$root.config.API_URL, "/sessions");

      if (this.$root.config.REDIRECT_ON_LOGOUT) {
        url += "?redirect_to=".concat(location.href);
      }

      return url;
    },
    avatarUrl: function avatarUrl() {
      if (this.user.avatarUrl && this.user.avatarUrl.startsWith('/')) {
        return this.$root.config.API_URL + this.user.avatarUrl;
      } else {
        return this.user.avatarUrl;
      }
    }
  },
  methods: {
    ordinalize: ordinalize,
    forceClose: function forceClose() {
      this.$emit('forceClose');
    },
    showWelcomePopup: function showWelcomePopup() {
      this.forceClose();
      this.$welcomePopup.show();
    }
  }
};
/* script */

var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__$2() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    staticClass: "logged-in-menu"
  }, [_c('li', [_c('RouterLink', {
    staticClass: "user link",
    attrs: {
      "to": "/account"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.forceClose($event);
      }
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "picture",
    attrs: {
      "src": _vm.avatarUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("\n          " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + "\n        ")]), _vm._v(" "), _vm.user.longestStreak && _vm.user.longestStreak.boxActivatedCount > 0 ? _c('span', {
    staticClass: "streaks"
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "streak"
    }
  }), _vm._v("\n          " + _vm._s(_vm.ordinalize(_vm.user.longestStreak.boxActivatedCount)) + " Streak >\n        ")], 1) : _c('span', {
    staticClass: "nostreak"
  }, [_vm._v("\n          No Streak Yet\n        ")])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('RouterLink', {
    staticClass: "link",
    attrs: {
      "to": "/dashboard"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.forceClose($event);
      }
    }
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "home"
    }
  }), _vm._v("\n      Home\n    ")], 1)], 1), _vm._v(" "), _c('li', [_c('RouterLink', {
    staticClass: "link",
    attrs: {
      "to": "/account"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.forceClose($event);
      }
    }
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "settings"
    }
  }), _vm._v("\n      Account Settings\n    ")], 1)], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://help.tokyotreat.com/hc/en-us",
      "target": "_blank"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.forceClose($event);
      }
    }
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "faq"
    }
  }), _vm._v("\n      FAQ\n    ")], 1)]), _vm._v(" "), _vm.$welcomePopup ? _c('li', {
    staticClass: "whatsnew"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showWelcomePopup
    }
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "invite"
    }
  }), _vm._v("\n      What's New?\n    ")], 1)]) : _vm._e(), _vm._v(" "), _c('li', [_c('form', {
    attrs: {
      "action": _vm.logoutUrl,
      "method": "POST"
    }
  }, [_c('input', {
    attrs: {
      "name": "_method",
      "value": "DELETE",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": "authenticity_token",
      "type": "hidden"
    },
    domProps: {
      "value": _vm.csrfToken
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "link",
    attrs: {
      "type": "submit"
    }
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": "logout"
    }
  }), _vm._v("\n        Logout\n      ")], 1)])])]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = "data-v-1cfba99f";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* component normalizer */

function __vue_normalize__$2(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__$2 = function __vue_create_injector__$2() {};
/* style inject SSR */


var LoggedInMenu = __vue_normalize__$2({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, __vue_create_injector__$2, undefined); //


var ICON_NAMES = {
  'box_packing': 'box',
  'box_shipped': 'delivery',
  'feature_deployed': 'new-feature',
  'incident_started': 'warning',
  'invoice_paid': 'invoice-paid',
  'streak_reminder': 'streak',
  'ticket_replied': 'faq-support'
};
var ICON_WRAPPER_GRADIENTS = {
  'box_packing': '-tokyotreat',
  'box_shipped': '-tokyotreat',
  'feature_deployed': '-gift',
  'incident_started': '-coupon',
  'invoice_paid': '-birthday',
  'streak_reminder': '-activate',
  'ticket_replied': '-activate'
};
var script$3 = {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  components: {
    Icon: Icon
  },
  computed: {
    wrapperClassName: function wrapperClassName() {
      return this.notification.seen ? '' : '-unseen';
    },
    iconName: function iconName() {
      return ICON_NAMES[this.notification.key] || 'alert';
    },
    iconWrapperClassName: function iconWrapperClassName() {
      return ICON_WRAPPER_GRADIENTS[this.notification.key] || '-activate';
    }
  }
};
/* script */

var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__$3() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('RouterLink', {
    staticClass: "notification-link",
    "class": _vm.wrapperClassName,
    attrs: {
      "to": _vm.notification.url
    }
  }, [_c('div', {
    staticClass: "iconwrapper",
    "class": _vm.iconWrapperClassName
  }, [_c('Icon', {
    staticClass: "icon",
    attrs: {
      "name": _vm.iconName
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.notification.title))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.notification.description))]), _vm._v(" "), _c('p', {
    staticClass: "timestamp"
  }, [_vm._v(_vm._s(_vm.notification.occurredAtRelative))])])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = "data-v-c6bfd456";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* component normalizer */

function __vue_normalize__$3(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__$3 = function __vue_create_injector__$3() {};
/* style inject SSR */


var NotificationItem = __vue_normalize__$3({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, __vue_create_injector__$3, undefined); //


var script$4 = {
  props: {
    notifications: {
      type: Array,
      required: true
    }
  },
  components: {
    Icon: Icon,
    NotificationItem: NotificationItem
  },
  methods: {
    forceClose: function forceClose() {
      this.$emit('forceClose');
    }
  }
};
/* script */

var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__$4() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "notifications-menu"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Notifications")]), _vm._v(" "), _vm.notifications.length ? [_c('ul', {
    staticClass: "list"
  }, _vm._l(_vm.notifications, function (notification) {
    return _c('li', {
      key: notification.id
    }, [_c('NotificationItem', {
      attrs: {
        "notification": notification
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.forceClose($event);
        }
      }
    })], 1);
  })), _vm._v(" "), _c('RouterLink', {
    staticClass: "all",
    attrs: {
      "to": "/notifications"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.forceClose($event);
      }
    }
  }, [_vm._v("\n      See All >\n    ")])] : [_c('p', {
    staticClass: "none"
  }, [_vm._v("No notifications yet")])]], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = "data-v-00f8db44";
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* component normalizer */

function __vue_normalize__$4(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__$4 = function __vue_create_injector__$4() {};
/* style inject SSR */


var NotificationsMenu = __vue_normalize__$4({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, __vue_create_injector__$4, undefined); //


var script$5 = {
  data: function data() {
    return {
      notificationsSeen: false,
      openMenu: undefined
    };
  },
  components: {
    LoginCheckQuery: LoginCheckQuery,
    LoggedInMenu: LoggedInMenu,
    NotificationsMenu: NotificationsMenu,
    Icon: Icon
  },
  created: function created() {
    document.addEventListener('click', this.forceClose);
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.forceClose);
  },
  computed: {
    loginPath: function loginPath() {
      return this.$root.config.LOGIN_URL;
    }
  },
  methods: {
    reload: function reload() {
      this.$refs.query.reload();
    },
    activeClassName: function activeClassName(name) {
      return this.openMenu === name ? '-active' : '';
    },
    toggleAccount: function toggleAccount() {
      if (this.openMenu == 'account') {
        this.openMenu = undefined;
      } else {
        this.openMenu = 'account';
      }
    },
    toggleNotifications: function toggleNotifications(csrfToken) {
      if (this.openMenu == 'notifications') {
        this.openMenu = undefined;
      } else {
        this.openMenu = 'notifications';
        this.markNotificationsSeen(csrfToken);
      }
    },
    markNotificationsSeen: function markNotificationsSeen(csrfToken) {
      var _this2 = this;

      makeAjaxRequest('POST', "".concat(this.$root.config.API_URL, "/notifications/seen_all"), {
        authenticity_token: csrfToken
      }).then(function () {
        return _this2.notificationsSeen = true;
      });
    },
    forceClose: function forceClose(e) {
      this.openMenu = undefined;
    }
  }
};
/* script */

var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__$5() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('LoginCheckQuery', {
    ref: "query",
    staticClass: "dropdown",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(ref) {
        var loaded = ref.loaded;
        var loggedIn = ref.loggedIn;
        var user = ref.user;
        var csrfToken = ref.csrfToken;
        return _c('div', {
          staticClass: "content"
        }, [!loaded ? _c('div', {
          staticClass: "placeholder"
        }) : _vm._e(), _vm._v(" "), loaded && loggedIn ? [_c('a', {
          staticClass: "toggle -notifications",
          "class": _vm.activeClassName('notifications'),
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              $event.stopPropagation();

              _vm.toggleNotifications(csrfToken);
            }
          }
        }, [_c('Icon', {
          staticClass: "icon",
          attrs: {
            "name": "notifications"
          }
        }), _vm._v(" "), !_vm.notificationsSeen && user.notifications.unseenCount ? _c('span', {
          staticClass: "unseencount"
        }, [_vm._v(_vm._s(user.notifications.unseenCount))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "menu -notifications",
          "class": _vm.activeClassName('notifications'),
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {}($event);
            }
          }
        }, [_c('NotificationsMenu', {
          attrs: {
            "notifications": user.notifications.recent
          },
          on: {
            "forceClose": _vm.forceClose
          }
        })], 1), _vm._v(" "), _c('a', {
          staticClass: "toggle -account",
          "class": _vm.activeClassName('account'),
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.toggleAccount($event);
            }
          }
        }, [_c('span', {
          staticClass: "desktop"
        }, [_vm._v("Account")]), _vm._v(" "), _c('Icon', {
          staticClass: "icon mobile",
          attrs: {
            "name": "profile-user"
          }
        }), _vm._v(" "), _c('Icon', {
          staticClass: "icon arrow",
          attrs: {
            "name": "chevron-down"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "menu",
          "class": _vm.activeClassName('account'),
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {}($event);
            }
          }
        }, [_c('LoggedInMenu', {
          attrs: {
            "user": user,
            "csrf-token": csrfToken
          },
          on: {
            "forceClose": _vm.forceClose
          }
        })], 1)] : _vm._e(), _vm._v(" "), loaded && !loggedIn ? [_c('a', {
          staticClass: "toggle login",
          attrs: {
            "href": _vm.loginPath
          }
        }, [_vm._v("Login")])] : _vm._e()], 2);
      }
    }])
  });
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = "data-v-b8da53c4";
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* component normalizer */

function __vue_normalize__$5(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {};

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */


var __vue_create_injector__$5 = function __vue_create_injector__$5() {};
/* style inject SSR */


var Dropdown = __vue_normalize__$5({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, __vue_create_injector__$5, undefined);

var instance = undefined;

function mount() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var element = document.querySelector('[data-component=profile-dropdown]');
  var datasetConstants = uppercaseKeys(element.dataset);
  var config = Object.assign(datasetConstants, options.config);

  if (config.ENABLED === false || config.ENABLED === 'false') {
    console.warn('Universal header is set to disabled; not rendering dropdown');
    return;
  }

  instance = new Vue(Object.assign({
    el: element,
    data: {
      config: config
    },
    render: function render(h) {
      return h(options.DropdownOverride || Dropdown, {
        ref: 'dropdown'
      });
    }
  }, options));
  return instance;
}

function reload() {
  if (instance && instance.$refs.dropdown) {
    instance.$refs.dropdown.reload();
  }
}

function uppercaseKeys(object) {
  var newObject = {};
  Object.keys(object).forEach(function (key) {
    // Convert lowerCamelCase to UPPER_SNAKE_CASE
    var newKey = key.replace(/([A-Z])/g, "_$1").toUpperCase();
    newObject[newKey] = object[key];
  });
  return newObject;
}

export { mount, reload };